import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseServiceV2 } from '@servicesv2';
import { ColunasFormulasComex } from 'models/formulas-comex/formulasComexViewModel';

@Injectable()
export class FormulasComexServiceV2 extends BaseServiceV2 {

    constructor(http: HttpClient) {
        super('FormulasComex', http);
    }

    getFormulasComex(campo: string) {
        return this.getAsPromise('GetByFormula/' + campo);
    }

    salvarFormulasComex(vm: any) {
        return this.postAsPromise<any, ColunasFormulasComex[]>(vm);
    }
}
